import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "HeaderInputsStack";

export const classes = {
  dateTextfield: `${PREFIX}-dateTextfield`,
};

export const HeaderInputsStack = styled(Stack)(({ theme }) => ({
  [`& .${classes.dateTextfield}`]: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.4)",
      },
      "&:hover fieldset": {
        borderColor: "black",
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary,
      },
    },
  },
}));
